import { takeLatest, put, call } from 'redux-saga/effects';
import { HTTP_HEADERS_FORMDATA } from '../../../constants';
import request from '../../../components/Utils/httpHelper';
import { RATINGS_DATA_UPLOAD, uploadRatingsDataResponse } from './action';
import { CORE_API } from '../../../config';

export function* uploadRatingsDataRequest(action){
    let requestURL = `${CORE_API}/ratings/upload`;
    const formData = new FormData();
    formData.append('file', action.data.file);
    formData.append('update', action.data.update);

    try {
        const data = yield call(request, requestURL, { method: 'POST', data: formData, headers: HTTP_HEADERS_FORMDATA });
        if(data && data.status == "200" ){
            yield put(uploadRatingsDataResponse({ data : data.data , status : "SUCCESS"}));
        }else{
            yield put(uploadRatingsDataResponse({ data : data.data , status :  "FAILURE"}));
        }
    }
    catch (err) {
        yield put(uploadRatingsDataResponse( { ...err.response , status : "FAILURE"}))
    }
}
 
export function* uploadRatingsData() {
    yield takeLatest(RATINGS_DATA_UPLOAD, uploadRatingsDataRequest);
}